import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import s from './WorkTracker.module.scss';

// Styled yes/no for every destructive action. Escape or the backdrop = no.
export default function ConfirmDialog({ confirm, onClose }) {
  const yesRef = useRef(null);
  useEffect(() => {
    if (!confirm) return undefined;
    yesRef.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [confirm, onClose]);
  if (!confirm) return null;
  return (
    <>
      <div className={s.backdrop} onClick={onClose} role="presentation" />
      <div className={s.dialog} role="alertdialog" aria-modal="true" aria-labelledby="wt-confirm-title">
        <h2 className={s.dialogTitle} id="wt-confirm-title">{confirm.title || 'Delete this?'}</h2>
        {confirm.text && <p className={s.dialogText}>{confirm.text}</p>}
        <div className={s.dialogActions}>
          <button type="button" className={s.btn} onClick={onClose}>No, keep it</button>
          <button
            type="button"
            ref={yesRef}
            className={s.btnDangerSolid}
            onClick={() => { onClose(); confirm.onConfirm(); }}
          >
            Yes, delete
          </button>
        </div>
      </div>
    </>
  );
}

ConfirmDialog.propTypes = {
  confirm: PropTypes.shape({ title: PropTypes.string, text: PropTypes.string, onConfirm: PropTypes.func.isRequired }),
  onClose: PropTypes.func.isRequired,
};
ConfirmDialog.defaultProps = { confirm: null };
